

setTimeout(() => {

  const targetDiv = document.querySelector('[data-option="customization_method"]');

  // Check if message already exists
  const existingMessage = document.querySelector(
    '[data-option="message_options"]'
  );

  if (targetDiv && !existingMessage) {

    targetDiv.insertAdjacentHTML(
      'beforebegin',
      `
      <div class="cl-po--option" data-option="message_options">
        <p style="font-weight: bold;">
          Minimum 12 quantities required to add to cart.
        </p>
      </div>
      `
    );

  }

}, 6000);

// let lastScrollTop = 0;
// const body = document.body;

// window.addEventListener("scroll", function () {
//   const currentScroll =
//     window.pageYOffset || document.documentElement.scrollTop;

//   if (currentScroll < lastScrollTop) {
//     // Scrolling up
//     body.classList.add("scrolling-up");
//     body.classList.remove("scrolling-down");
//   } else {
//     // Scrolling down
//     body.classList.add("scrolling-down");
//     body.classList.remove("scrolling-up");
//   }

//   lastScrollTop = currentScroll <= 0 ? 0 : currentScroll; // Avoid negative values
// });




// // ===== Sticky Selected Color Preview =====
// var colorStickyState = {
//   isVisible: false
// };

// function createColorSticky() {
//   // Only on mobile
//   if (window.innerWidth > 768) return null;
  
//   var sticky = document.getElementById('cl-color-sticky-preview');
//   if (!sticky) {
//     sticky = document.createElement('div');
//     sticky.id = 'cl-color-sticky-preview';
//     sticky.style.position = 'fixed';
//     sticky.style.top = '0';
//     sticky.style.left = '0';
//     sticky.style.right = '0';
//     sticky.style.zIndex = '10000';
//     sticky.style.backgroundColor = 'white';
//     sticky.style.padding = '8px 15px';
//     sticky.style.borderBottom = '2px solid #e5e7eb';
//     sticky.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
//     sticky.style.display = 'flex';
//     sticky.style.alignItems = 'center';
//     sticky.style.justifyContent = 'center';
//     sticky.style.minHeight = '60px';
//     document.body.appendChild(sticky);
//   }
//   return sticky;
// }

// function updateColorSticky(colorInput) {
//   if (window.innerWidth > 768) return;
  
//   var sticky = createColorSticky();
//   if (!sticky) return;
  
//   var img = colorInput.closest('label').querySelector('img');
//   if (img && img.src) {
//     sticky.innerHTML = '';
//     var imgClone = document.createElement('img');
//     imgClone.src = img.src;
//     imgClone.style.width = '135px';
//     imgClone.style.height = '135px';
//     imgClone.style.objectFit = 'cover';
//     imgClone.style.borderRadius = '4px';    
//     sticky.appendChild(imgClone);
//     colorStickyState.isVisible = true;
    
//     // Show/hide based on scroll
//     if (window.scrollY > 300) {
//       sticky.style.display = 'flex';
//     } else {
//       sticky.style.display = 'none';
//     }
//   }
// }

// // Initialize on page load
// function initializeColorSticky() {
//   if (window.innerWidth > 768) return;
  
//   setTimeout(function() {
//     var colorInput = document.querySelector('[data-option="Color"] input[name="v_Color"]:checked');
//     if (colorInput) {
//       updateColorSticky(colorInput);
//     }
//   }, 500);
// }

// // Listen to the custom option:changed event
// window.addEventListener('option:changed', function(e) {
//   var option = e.detail;
  
//   if (option.name === 'Color') {
//     var colorInput = document.querySelector('[data-option="Color"] input[name="v_Color"]:checked');
//     if (colorInput) {
//       updateColorSticky(colorInput);
//     }
//   }
// });



// // Hide sticky when scrolled to top
// window.addEventListener('scroll', function() {
//   if (window.innerWidth > 768) return;
  
//   var sticky = document.getElementById('cl-color-sticky-preview');
//   if (!sticky || !colorStickyState.isVisible) return;
  
//   if (window.scrollY < 300) {
//     sticky.style.display = 'none';
//   } else {
//     sticky.style.display = 'flex';
//   }
// });

// // Handle resize
// window.addEventListener('resize', function() {
//   if (window.innerWidth > 768) {
//     var sticky = document.getElementById('cl-color-sticky-preview');
//     if (sticky) sticky.style.display = 'none';
//   } else {
//     initializeColorSticky();
//   }
// });

// // Initialize on page load
// if (document.readyState === 'loading') {
//   document.addEventListener('DOMContentLoaded', initializeColorSticky);
// } else {
//   initializeColorSticky();
// }





// // Sticky color image preview on mobile only
// (function() {
//   // Check if on mobile
//   function isMobile() {
//     return window.innerWidth <= 768;
//   }

//   // Create sticky color bar
//   function createStickyBar() {
//     const existingBar = document.getElementById('cl-color-sticky-bar');
//     if (existingBar) return;

//     const stickyBar = document.createElement('div');
//     stickyBar.id = 'cl-color-sticky-bar';
//     stickyBar.style.cssText = `
//       position: fixed;
//       top: 0;
//       left: 0;
//       right: 0;
//       background: white;
//       border-bottom: 1px solid #e5e7eb;
//          z-index: 100;
//       display: none;
//       justify-content: center;
//       align-items: center;
//       box-shadow: 0 2px 4px rgba(0,0,0,0.1);
//     `;

//     const imageContainer = document.createElement('div');
//     imageContainer.id = 'cl-color-sticky-image';
//     imageContainer.style.cssText = `
//       width: 135px;
//       height: 135px;
//         overflow: hidden;
//       flex-shrink: 0;
//     `;

//     stickyBar.appendChild(imageContainer);

//     // Add to the top of page
//     document.body.prepend(stickyBar);
//   }

//   // Update sticky bar when color changes
//   function updateStickyBar() {
//     const colorOption = document.querySelector('[data-option="Color"]');
//     const stickyBar = document.getElementById('cl-color-sticky-bar');
//     const imageContainer = document.getElementById('cl-color-sticky-image');

//     if (!colorOption || !stickyBar || !imageContainer) return;

//     const selectedInput = colorOption.querySelector('input[type="radio"]:checked');
    
//     if (selectedInput) {
//       const swatch = selectedInput.nextElementSibling;
//       const img = swatch.querySelector('img');

//       if (img) {
//         // Clear previous content
//         imageContainer.innerHTML = '';

//         // Clone and append new image
//         const newImg = img.cloneNode(true);
//         newImg.style.cssText = `
//           width: 100%;
//           height: 100%;
//           object-fit: contain;
//         `;
//         imageContainer.appendChild(newImg);
//       }
//     }
//   }

//   // Handle scroll and visibility
//   function handleScroll() {
//     if (!isMobile()) {
//       const stickyBar = document.getElementById('cl-color-sticky-bar');
//       if (stickyBar) stickyBar.style.display = 'none';
//       return;
//     }

//     const colorOption = document.querySelector('[data-option="Color"]');
//     const stickyBar = document.getElementById('cl-color-sticky-bar');

//     if (!colorOption || !stickyBar) return;

//     const colorRect = colorOption.getBoundingClientRect();
//     const selectedInput = colorOption.querySelector('input[type="radio"]:checked');

//     // Show sticky bar only when color option is not visible and a color is selected
//     if (selectedInput && colorRect.top > window.innerHeight) {
//       // Color option is below viewport
//       stickyBar.style.display = 'flex';
//     } else if (colorRect.bottom < 0) {
//       // Color option is above viewport
//       stickyBar.style.display = 'flex';
//     } else {
//       // Color option is visible on screen
//       stickyBar.style.display = 'none';
//     }
//   }

//   // Initialize on load
//   function init() {
//     if (!isMobile()) return;

//     createStickyBar();
//     updateStickyBar();

//     // Listen for color changes
//     window.addEventListener('option:changed', function(e) {
//       if (e.detail && e.detail.name === 'Color') {
//         updateStickyBar();
//       }
//     });

//     // Listen for scroll
//     window.addEventListener('scroll', handleScroll);

//     // Handle window resize
//     window.addEventListener('resize', function() {
//       if (!isMobile()) {
//         const stickyBar = document.getElementById('cl-color-sticky-bar');
//         if (stickyBar) stickyBar.style.display = 'none';
//       }
//     });
//   }

//   // Run when DOM is ready
//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', init);
//   } else {
//     init();
//   }
// })();

// Function to create minimum quantity message
function createMinimumQtyMessage() {
  var existingMessage = document.getElementById('cl-min-qty-message');
  if (existingMessage) return;

  var atcButton = document.querySelector('.product-form__buttons');
  if (!atcButton) return;

  var message = document.createElement('div');
  message.id = 'cl-min-qty-message';
  message.style.cssText = `
    color: #dc2626;
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    margin-bottom: 12px;
    padding: 10px;
    background-color: #fee2e2;
    border-radius: 6px;
    display: none;
  `;
  message.textContent = 'Minimum 12 items required to proceed';

  atcButton.parentNode.insertBefore(message, atcButton);
}

// Function to extract price from text (e.g., "$24.00 USD" -> 24.00)
function extractPrice(priceText) {
  var match = priceText.match(/\$?([\d,]+\.?\d*)/);
  if (match) {
    return parseFloat(match[1].replace(/,/g, ''));
  }
  return 0;
}

// Function to format price (e.g., 24.00 -> "$24.00 USD")
function formatPrice(price) {
  return '$' + price.toFixed(2) + ' USD';
}

// Function to format price without USD (e.g., 24.00 -> "$24.00")
function formatPriceSimple(price) {
  return '$' + price.toFixed(2);
}

// Function to update price display based on quantity
function updatePriceDisplay(totalQty) {
  var priceElement = document.querySelector('.subtotal_price_cstm');
  var pipsaveElement = document.querySelector('.pipsave');
  
  if (!priceElement) {
    console.log('Price element not found');
    return;
  }
  
  // Get the current price text from the element
  var currentPriceText = priceElement.textContent;
  var currentPrice = extractPrice(currentPriceText);
  
  console.log('=== PRICE CALCULATION ===');
  console.log('Price text from div:', currentPriceText);
  console.log('Extracted price:', currentPrice);
  console.log('Total qty:', totalQty);
  
  if (totalQty > 0 && currentPrice > 0) {
    // Calculate unit price from current price and quantity
    var unitPrice = currentPrice / totalQty;
    
    console.log('Unit price (price ÷ qty):', unitPrice);
    console.log('Calculation: ' + currentPrice + ' ÷ ' + totalQty + ' = ' + unitPrice);
    
    // Update the .pipsave element with complete HTML (per item price only)
    if (pipsaveElement) {
      pipsaveElement.innerHTML = '(<div class="total_save_price"><p>Per Item =</p><span class="piprice">' + formatPriceSimple(unitPrice) + '</span></div>)';
      console.log('Updated .pipsave HTML with unit price:', formatPriceSimple(unitPrice));
    }
    
    if (totalQty < 12) {
  
      // Show unit price only when qty < 12
      console.log('Qty < 12, showing unit price:', totalPrice);
      priceElement.textContent = formatPrice(totalPrice);
    } else {
      // Show total price when qty >= 12
      var totalPrice = unitPrice * totalQty;
      console.log('Qty >= 12, showing total price:', totalPrice);
      priceElement.textContent = formatPrice(totalPrice);
    }
  }
}

// Function to update main quantity from custom size quantities
function syncQuantityToMain() {

    // Get ALL custom_qty fields dynamically
    var qtyInputs = document.querySelectorAll(
        '[data-option^="custom_qty_"] .cl-po--quantity'
    );

    var totalQty = 0;

    qtyInputs.forEach(function(input) {
        totalQty += parseInt(input.value) || 0;
    });

    console.log('Total Quantity Calculated:', totalQty);

    // Update main quantity field
    var mainQtyInput = document.querySelector('input[name="quantity"]');

    if (mainQtyInput) {

        mainQtyInput.value = totalQty;

        // Trigger change event
        mainQtyInput.dispatchEvent(
            new Event('change', { bubbles: true })
        );
    }

    // Update Add to Cart button state and price
    updateAddToCartButton(totalQty);
    updatePriceDisplay(totalQty);
// alert(totalQty);
}

// Function to disable/enable Add to Cart button based on quantity
function updateAddToCartButton(totalQty) {
    var atcButton = document.querySelector('.product-form__buttons');
    var message = document.getElementById('cl-min-qty-message');
    
    if (atcButton) {
        if (totalQty < 12) {
            // Add disabled class
            atcButton.classList.add('disabled');
            // Show message
            if (message) {
                message.style.display = 'block';
            }
        } else {
            // Remove disabled class
            atcButton.classList.remove('disabled');
            // Hide message
            if (message) {
                message.style.display = 'none';
            }
        }
    }
}

// Call sync on page load
setTimeout(function() {
    createMinimumQtyMessage();
    syncQuantityToMain();
}, 2000);

// Listen for changes in custom_qty fields
window.addEventListener('option:changed', function(e) {

    var option = e.detail;

    // Any field starting with custom_qty_
    if (option.name && option.name.startsWith('custom_qty_')) {

        syncQuantityToMain();

    }

});

// Handle dynamic quantity fields + size selection

document.addEventListener('click', function(e) {

    // +/- quantity buttons
    if (
        e.target.classList.contains('cl-po--quantity-btn')
    ) {

        var optionWrap = e.target.closest(
            '[data-option^="custom_qty_"]'
        );

        if (optionWrap) {

            setTimeout(function() {

                syncQuantityToMain();

            }, 100);

        }

    }

    // Size swatches ONLY
  if (
      e.target.classList.contains('cl-po--swatch-button') &&
      e.target.closest('[data-option="Size"]')
  ) {

        // Wait for quantity fields to render
        setTimeout(function() {

            syncQuantityToMain();

        }, 500);

            }

        });


// Manual typing inside quantity fields
// document.addEventListener('input', function(e) {

//     if (
//         e.target.matches(
//             '[data-option^="custom_qty_"] .cl-po--quantity'
//         )
//     ) {

//         syncQuantityToMain();

//     }

// });

